'use client'

export function PageClient() {
  return null
}
